import en from '~i18n/en';
import { EN } from '~i18n/languages';

const maps = {
  [EN]: en
};

export default maps;
